import React, { Fragment } from 'react';
import { Disclosure } from '@headlessui/react';
import Utilities from '@util/Utilities';
import FooterFragment from '@app/site/secured/_common/layout/fragment/FooterFragment';


const MockDashboard = React.memo(() => {
    const days = [
        {day: "28", date: '2023-12-28', events: []},
        {day: "29", date: '2023-12-29', events: []},
        {day: "30", date: '2023-12-30', events: []},
        {day: "31", date: '2023-12-31', events: []},
        {day: "01", date: '2024-01-01', isCurrentMonth: true, events: []},
        {day: "02", date: '2024-01-02', isCurrentMonth: true, events: []},
        {
            day: "03", date: '2024-01-03',
            isCurrentMonth: true,
        },
        {day: "04", date: '2024-01-04', isCurrentMonth: true, events: []},
        {day: "05", date: '2024-01-05', isCurrentMonth: true, events: []},
        {day: "06", date: '2024-01-06', isCurrentMonth: true, events: []},
        {
            day: "07", date: '2024-01-07',
            isCurrentMonth: true,
        },
        {day: "08", date: '2024-01-08', isCurrentMonth: true, events: []},
        {day: "09", date: '2024-01-09', isCurrentMonth: true, events: []},
        {day: "10", date: '2024-01-10', isCurrentMonth: true, events: []},
        {day: "11", date: '2024-01-11', isCurrentMonth: true, events: []},
        {
            day: "12",
            date: '2024-01-12',
            isCurrentMonth: true,
            isToday: true,
        },
        {day: "13", date: '2024-01-13', isCurrentMonth: true, events: []},
        {day: "14", date: '2024-01-14', isCurrentMonth: true, events: []},
        {day: "15", date: '2024-01-15', isCurrentMonth: true, events: []},
        {day: "16", date: '2024-01-16', isCurrentMonth: true, events: []},
        {day: "17", date: '2024-01-17', isCurrentMonth: true, events: []},
        {day: "18", date: '2024-01-18', isCurrentMonth: true, events: []},
        {day: "19", date: '2024-01-19', isCurrentMonth: true, events: []},
        {day: "20", date: '2024-01-20', isCurrentMonth: true, events: []},
        {day: "21", date: '2024-01-21', isCurrentMonth: true, events: []},
        {
            day: "22",
            date: '2024-01-22',
            isCurrentMonth: true,
            isSelected: true,
        },
        {day: "23", date: '2024-01-23', isCurrentMonth: true, events: []},
        {day: "24", date: '2024-01-24', isCurrentMonth: true, events: []},
        {day: "25", date: '2024-01-25', isCurrentMonth: true, events: []},
        {day: "26", date: '2024-01-26', isCurrentMonth: true, events: []},
        {day: "27", date: '2024-01-27', isCurrentMonth: true, events: []},
        {day: "28", date: '2024-01-28', isCurrentMonth: true, events: []},
        {day: "29", date: '2024-01-29', isCurrentMonth: true, events: []},
        {day: "30", date: '2024-01-30', isCurrentMonth: true, events: []},
        {day: "31", date: '2024-01-31', isCurrentMonth: true, events: []},

    ]

    return <><Disclosure as="nav" className="border-b border-gray-200 bg-white">
        {({open}) => (
            <>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 justify-between">
                        <div className="flex">
                            <div className="flex flex-shrink-0 items-center">
                                <img
                                    className="block h-8 w-auto lg:hidden"
                                    src="/assets/img/brand/rp-icon.svg"
                                    alt="RoomPulse"
                                />
                                <img
                                    className="hidden h-6 w-auto lg:block"
                                    src="/assets/img/brand/rp-logo.svg"
                                    alt="RoomPulse"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </Disclosure>
        {/* Main Content */}
        <main>
            {/* Content */}
            <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
                <div className="lg:flex lg:h-full lg:flex-col">
                    {/* Calendar */}
                    <div className="shadow ring-1 ring-black ring-opacity-5 lg:flex lg:flex-auto lg:flex-col">
                        {/* Calendar Days */}
                        <div
                            className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-200 text-center text-xs font-semibold leading-6 text-gray-700 lg:flex-none">
                            <div className="bg-white py-2">M<span className="sr-only sm:not-sr-only">on</span></div>
                            <div className="bg-white py-2">T<span className="sr-only sm:not-sr-only">ue</span></div>
                            <div className="bg-white py-2">W<span className="sr-only sm:not-sr-only">ed</span></div>
                            <div className="bg-white py-2">T<span className="sr-only sm:not-sr-only">hu</span></div>
                            <div className="bg-white py-2">F<span className="sr-only sm:not-sr-only">ri</span></div>
                            <div className="bg-white py-2">S<span className="sr-only sm:not-sr-only">at</span></div>
                            <div className="bg-white py-2">S<span className="sr-only sm:not-sr-only">un</span></div>
                        </div>
                        <div className="flex bg-gray-200 text-xs leading-6 text-gray-700 lg:flex-auto">
                            {/* Calendar for desktop */}
                            <div className="hidden w-full lg:grid lg:grid-cols-7 lg:grid-rows-5 lg:gap-px">
                                {days.map(day => <div key={day.date} className="relative bg-white">
                                    <div className="flex flex-col justify-between h-full">
                                        <div className="px-3 py-2">
                                            <time dateTime="2024-01-11">{day.day}</time>
                                        </div>
                                        <div className="px-3 py-2">
                                            <div className="w-full animate-pulse">
                                                <div className="h-4 bg-gray-200 rounded-full w-12 mb-4"></div>
                                                <div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
                                                <div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>)}


                            </div>
                            {/* Calendar for Small Screens */}
                            <div className="isolate grid w-full grid-cols-7 grid-rows-6 gap-px lg:hidden">
                                {days.map((day) => (
                                    <button
                                        key={day.date}
                                        type="button"
                                        className={Utilities.classNames(
                                            day.isCurrentMonth ? 'bg-white' : 'bg-gray-50',
                                            (day.isSelected || day.isToday) && 'font-semibold',
                                            day.isSelected && 'text-white',
                                            !day.isSelected && day.isToday && 'text-blue-600',
                                            !day.isSelected && day.isCurrentMonth && !day.isToday && 'text-gray-900',
                                            !day.isSelected && !day.isCurrentMonth && !day.isToday && 'text-gray-500',
                                            'flex flex-col px-3 py-2 hover:bg-gray-100 focus:z-10'
                                        )}
                                    >
                                        <time
                                            dateTime={day.date}
                                            className={Utilities.classNames(
                                                day.isSelected && 'flex h-6 w-6 items-center justify-center rounded-full',
                                                day.isSelected && day.isToday && 'bg-blue-600',
                                                day.isSelected && !day.isToday && 'bg-gray-900',
                                                'ml-auto'
                                            )}
                                        >
                                            {day.date.split('-').pop()!.replace(/^0/, '')}
                                        </time>
                                        <div className="w-full animate-pulse mt-2">
                                            <div className="h-2.5 bg-gray-200 rounded-full"></div>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <FooterFragment/>
    </>
})

export default MockDashboard;